var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "banner-component" },
    [
      _c(
        "div",
        { staticClass: "header-actions" },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "150px", "margin-right": "10px" },
              attrs: { placeholder: "请选择发布位置" },
              model: {
                value: _vm.publishPositionFilter,
                callback: function ($$v) {
                  _vm.publishPositionFilter = $$v
                },
                expression: "publishPositionFilter",
              },
            },
            _vm._l(_vm.publishPositionOptions, function (item) {
              return _c("el-option", {
                key: item.value,
                attrs: { label: item.label, value: item.value },
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.loadConfig } },
            [_vm._v("查询")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleAdd } },
            [_vm._v("添加")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.bannerList, border: "" },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "55" } }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", width: "80" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "名称", "min-width": "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.extra.name))])]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "素材", "min-width": "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.extra.imageUrl
                      ? _c("div", { staticClass: "image-cell" }, [
                          _vm.isVideoFile(scope.row.extra.imageUrl)
                            ? _c("div", { staticClass: "video-thumb-wrap" }, [
                                _c("video", {
                                  staticClass: "table-preview-img",
                                  attrs: {
                                    src: _vm.getImageUrl(
                                      scope.row.extra.imageUrl
                                    ),
                                    muted: "",
                                  },
                                  domProps: { muted: true },
                                }),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass:
                                    "el-icon-video-play video-play-icon",
                                }),
                              ])
                            : _c("img", {
                                staticClass: "table-preview-img",
                                attrs: {
                                  src: _vm.getImageUrl(
                                    scope.row.extra.imageUrl
                                  ),
                                  alt: "Banner图片",
                                },
                              }),
                        ])
                      : _c("div", { staticClass: "no-image" }, [
                          _vm._v("无素材"),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "跳转地址", "min-width": "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.getPageNameByUrl(scope.row.extra.jumpUrl) +
                            (scope.row.extra.param
                              ? "?" + scope.row.extra.param
                              : "")
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "发布位置", "min-width": "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.getPublishPositionLabel(
                            scope.row.extra.publishPosition
                          )
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "城市", "min-width": "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    Array.isArray(scope.row.extra.city) &&
                    scope.row.extra.city.includes(-1)
                      ? _c("span", [_vm._v("全部")])
                      : _c("span", [
                          _vm._v(
                            _vm._s(
                              Array.isArray(scope.row.extra.city)
                                ? scope.row.extra.city
                                    .map(function (id) {
                                      return _vm.getCityNameById(id)
                                    })
                                    .join(", ")
                                : scope.row.extra.city
                                ? _vm.getCityNameById(scope.row.extra.city)
                                : "全部"
                            )
                          ),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c(
            "el-table-column",
            {
              attrs: { label: "排序", width: "80" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [_c("span", [_vm._v(_vm._s(scope.row.sort))])]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c(
                    "el-tooltip",
                    { attrs: { content: "序号越大越靠前", placement: "top" } },
                    [
                      _c("span", [
                        _vm._v("排序 "),
                        _c("i", { staticClass: "el-icon-question" }),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "是否显示", width: "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-switch", {
                      attrs: {
                        "active-color": "#67C23A",
                        "inactive-color": "#dcdfe6",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handleToggleVisible(scope.row)
                        },
                      },
                      model: {
                        value: scope.row.enable,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "enable", $$v)
                        },
                        expression: "scope.row.enable",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", "min-width": "150", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(scope.row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "divider" }, [_vm._v("|")]),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleRemove(scope.row)
                          },
                        },
                      },
                      [_vm._v("移除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
              "current-page": _vm.currentPage,
              "page-size": _vm.pageSize,
              "page-sizes": [5, 10, 20, 50],
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            width: "950px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.resetForm,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.formData,
                rules: _vm.rules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "发布位置", prop: "publishPosition" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择发布位置" },
                      on: {
                        change: function ($event) {
                          return _vm.handlePublishPositionChange(_vm.formData)
                        },
                      },
                      model: {
                        value: _vm.formData.publishPosition,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "publishPosition", $$v)
                        },
                        expression: "formData.publishPosition",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "首页-顶部", value: "top" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "首页-底部", value: "bottom" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "首页-中部", value: "middle" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "名称", prop: "name" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入名称" },
                            model: {
                              value: _vm.formData.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "name", $$v)
                              },
                              expression: "formData.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "说明", prop: "desc" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入说明",
                              type: "textarea",
                              rows: 3,
                            },
                            model: {
                              value: _vm.formData.desc,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "desc", $$v)
                              },
                              expression: "formData.desc",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.formData.publishPosition == "top"
                ? [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "跳转页面", prop: "jumpUrl" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    key: "jumpUrl-select",
                                    attrs: {
                                      placeholder: "请选择跳转页面",
                                      filterable: "",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.formData.jumpUrl,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "jumpUrl", $$v)
                                      },
                                      expression: "formData.jumpUrl",
                                    },
                                  },
                                  _vm._l(_vm.pageList, function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label:
                                          item.pageName +
                                          "(" +
                                          item.appid +
                                          ")",
                                        value: item.pageUrl,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "跳转参数", prop: "param" } },
                              [
                                _c("el-input", {
                                  staticClass: "param-input",
                                  attrs: { placeholder: "请输入参数" },
                                  model: {
                                    value: _vm.formData.param,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "param", $$v)
                                    },
                                    expression: "formData.param",
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "param-tip" }, [
                                  _vm._v("示例：id=123 或 name=test"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "分组类型", prop: "groupType" },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { placeholder: "请选择分组类型" },
                                    on: { change: _vm.handleGroupTypeChange },
                                    model: {
                                      value: _vm.formData.groupType,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "groupType", $$v)
                                      },
                                      expression: "formData.groupType",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "不匹配分组", value: 0 },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "CDP分组", value: 1 },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "消费行为", value: 2 },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _vm.formData.groupType != 0
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "选择分组",
                                      prop: "groupId",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        key: "groupId-select",
                                        staticClass: "inline-select",
                                        attrs: {
                                          placeholder: "请选择分组",
                                          clearable: "",
                                          filterable: "",
                                          remote: "",
                                          "remote-method": _vm.queryGroupList,
                                          loading: _vm.groupLoading,
                                        },
                                        model: {
                                          value: _vm.formData.groupId,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "groupId",
                                              $$v
                                            )
                                          },
                                          expression: "formData.groupId",
                                        },
                                      },
                                      _vm._l(_vm.groupOptions, function (item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.label,
                                            value: item.value,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "是否会员", prop: "isMember" },
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    model: {
                                      value: _vm.formData.isMember,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "isMember", $$v)
                                      },
                                      expression: "formData.isMember",
                                    },
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: "1" } }, [
                                      _vm._v("全部"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-radio", { attrs: { label: "2" } }, [
                                      _vm._v("是"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-radio", { attrs: { label: "3" } }, [
                                      _vm._v("否"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.formData.isMember == 2
                      ? _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "会员等级",
                                      prop: "memberLevel",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-checkbox-group",
                                      {
                                        model: {
                                          value: _vm.formData.memberLevel,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "memberLevel",
                                              $$v
                                            )
                                          },
                                          expression: "formData.memberLevel",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-checkbox",
                                          { attrs: { label: "1" } },
                                          [_vm._v("lv1")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-checkbox",
                                          { attrs: { label: "2" } },
                                          [_vm._v("lv2")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-checkbox",
                                          { attrs: { label: "3" } },
                                          [_vm._v("lv3")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-checkbox",
                                          { attrs: { label: "4" } },
                                          [_vm._v("lv4")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-checkbox",
                                          { attrs: { label: "5" } },
                                          [_vm._v("lv5")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "添加企微",
                                  prop: "isAddWechat",
                                },
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    model: {
                                      value: _vm.formData.isAddWechat,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "isAddWechat",
                                          $$v
                                        )
                                      },
                                      expression: "formData.isAddWechat",
                                    },
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: "1" } }, [
                                      _vm._v("全部"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-radio", { attrs: { label: "2" } }, [
                                      _vm._v("是"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-radio", { attrs: { label: "3" } }, [
                                      _vm._v("否"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "是否下单", prop: "isOrdered" },
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    model: {
                                      value: _vm.formData.isOrdered,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "isOrdered", $$v)
                                      },
                                      expression: "formData.isOrdered",
                                    },
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: "1" } }, [
                                      _vm._v("全部"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-radio", { attrs: { label: "2" } }, [
                                      _vm._v("下过单"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-radio", { attrs: { label: "3" } }, [
                                      _vm._v("未下过单"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "新人券是否过期",
                                  prop: "isNewUserCouponExpired",
                                },
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    model: {
                                      value:
                                        _vm.formData.isNewUserCouponExpired,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "isNewUserCouponExpired",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formData.isNewUserCouponExpired",
                                    },
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: "1" } }, [
                                      _vm._v("全部"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-radio", { attrs: { label: "2" } }, [
                                      _vm._v("新人券过期"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-radio", { attrs: { label: "3" } }, [
                                      _vm._v("新人券未过期"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm.formData.publishPosition == "bottom"
                ? [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "链接类型", prop: "linkType" },
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    on: { change: _vm.handleLinkTypeChange },
                                    model: {
                                      value: _vm.formData.linkType,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "linkType", $$v)
                                      },
                                      expression: "formData.linkType",
                                    },
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: "1" } }, [
                                      _vm._v("下拉选择内容"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-radio", { attrs: { label: "2" } }, [
                                      _vm._v("外链地址输入"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.formData.linkType === "1"
                      ? _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "选择页面",
                                      prop: "jumpUrl",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        key: "jumpUrl-select",
                                        attrs: {
                                          placeholder: "请选择跳转页面",
                                          filterable: "",
                                          clearable: "",
                                        },
                                        model: {
                                          value: _vm.formData.jumpUrl,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "jumpUrl",
                                              $$v
                                            )
                                          },
                                          expression: "formData.jumpUrl",
                                        },
                                      },
                                      _vm._l(_vm.pageList, function (item) {
                                        return _c("el-option", {
                                          key: item.id,
                                          attrs: {
                                            label:
                                              item.pageName +
                                              "(" +
                                              item.appid +
                                              ")",
                                            value: item.pageUrl,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.formData.linkType === "2"
                      ? _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "元素外链地址",
                                      prop: "jumpUrl",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "请输入跳转地址" },
                                      model: {
                                        value: _vm.formData.jumpUrl,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.formData, "jumpUrl", $$v)
                                        },
                                        expression: "formData.jumpUrl",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "跳转参数", prop: "param" } },
                              [
                                _c("el-input", {
                                  staticClass: "param-input",
                                  attrs: { placeholder: "请输入参数" },
                                  model: {
                                    value: _vm.formData.param,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "param", $$v)
                                    },
                                    expression: "formData.param",
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "param-tip" }, [
                                  _vm._v("示例：id=123 或 name=test"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "城市", prop: "city" } },
                        [
                          _c(
                            "el-select",
                            {
                              key: "city-select",
                              attrs: {
                                placeholder: "请选择城市",
                                clearable: "",
                                filterable: "",
                                multiple: "",
                              },
                              on: { change: _vm.handleCityChange },
                              model: {
                                value: _vm.formData.city,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "city", $$v)
                                },
                                expression: "formData.city",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: "全部",
                                  value: -1,
                                  disabled:
                                    _vm.formData.city.length > 0 &&
                                    !_vm.formData.city.includes(-1),
                                },
                              }),
                              _vm._v(" "),
                              _vm._l(_vm.regionList, function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: {
                                    label: item.name,
                                    value: item.id,
                                    disabled: _vm.formData.city.includes(-1),
                                  },
                                })
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "排序", prop: "sort" } },
                        [
                          _c("el-input-number", {
                            attrs: {
                              min: 1,
                              max: 999,
                              "controls-position": "right",
                            },
                            model: {
                              value: _vm.formData.sort,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "sort", $$v)
                              },
                              expression: "formData.sort",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "素材", prop: "imageUrl" } },
                [
                  _c("div", { staticClass: "image-upload-container" }, [
                    _c("input", {
                      ref: "fileInput",
                      staticStyle: { display: "none" },
                      attrs: {
                        type: "file",
                        accept: "image/*,video/mp4,video/3gpp,.m3u8",
                      },
                      on: { change: _vm.handleFileChange },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "upload-area" }, [
                      _c(
                        "div",
                        {
                          staticClass: "image-preview",
                          on: { click: _vm.handleImageClick },
                        },
                        [
                          _vm.formData.imageUrl &&
                          _vm.isVideoFile(_vm.formData.imageUrl)
                            ? _c("div", { staticClass: "video-preview-wrap" }, [
                                _c("video", {
                                  staticClass: "preview-img",
                                  attrs: {
                                    src: _vm.getImageUrl(_vm.formData.imageUrl),
                                    muted: "",
                                  },
                                  domProps: { muted: true },
                                }),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass:
                                    "el-icon-video-play video-play-icon",
                                }),
                              ])
                            : _vm.formData.imageUrl
                            ? _c("img", {
                                staticClass: "preview-img",
                                attrs: {
                                  src: _vm.getImageUrl(_vm.formData.imageUrl),
                                  alt: "Banner图片",
                                },
                              })
                            : _c("div", { staticClass: "image-placeholder" }, [
                                _c("i", {
                                  staticClass: "el-icon-picture-outline",
                                }),
                                _vm._v(" "),
                                _c("p", [_vm._v("点击上传图片/视频")]),
                              ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "upload-tip" }, [
                      _vm._v(
                        "支持 jpg、png、gif、mp4、3gp、m3u8 格式，图片不超过5MB，视频不超过50MB"
                      ),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "是否显示", prop: "enable" } },
                        [
                          _c("el-switch", {
                            model: {
                              value: _vm.formData.enable,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "enable", $$v)
                              },
                              expression: "formData.enable",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "展示平台", prop: "platform" } },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              model: {
                                value: _vm.formData.platform,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "platform", $$v)
                                },
                                expression: "formData.platform",
                              },
                            },
                            [
                              _c("el-checkbox", { attrs: { label: "wx" } }, [
                                _vm._v("微信"),
                              ]),
                              _vm._v(" "),
                              _c("el-checkbox", { attrs: { label: "ali" } }, [
                                _vm._v("支付宝"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.previewVisible,
            title: "预览二维码",
            width: "600px",
            "before-close": _vm.handlePreviewClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "preview-dialog-content" }, [
            _c("img", {
              staticClass: "preview-image",
              staticStyle: {
                "max-width": "100%",
                height: "auto",
                display: "block",
                margin: "0 auto",
              },
              attrs: { src: _vm.previewImageUrl, alt: "预览二维码" },
            }),
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.previewVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }